import { Controller, FieldPath, FieldValues } from 'react-hook-form'

import { Select as SelectRoot } from 'components/Select'
import { SelectProps } from './types'

export const Select = <Schema extends FieldValues, Data>({
  control,
  name,
  onChange,
  ...selectProps
}: SelectProps<Schema, Data>): React.JSX.Element => (
  <Controller
    control={control}
    name={name as FieldPath<Schema>}
    render={({ field: { onChange: formOnChange, value }, fieldState: { error } }) => (
      <SelectRoot<Data>
        {...selectProps}
        error={Boolean(error)}
        helperText={error?.message}
        id={name}
        name={name}
        onChange={onChange || formOnChange}
        value={value || ''}
      />
    )}
  />
)
